import { render, staticRenderFns } from "./ShippingAddr.vue?vue&type=template&id=a2ab97fe&scoped=true&"
import script from "./ShippingAddr.vue?vue&type=script&lang=js&"
export * from "./ShippingAddr.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddr.vue?vue&type=style&index=0&id=a2ab97fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ab97fe",
  null
  
)

export default component.exports